/**
 * Generic GraphQL request handler for the Calendar API.
 * @param query The GraphQL query or mutation string.
 * @param variables Optional variables for the query/mutation.
 * @returns Promise resolving to the GraphQL response data.
 */
async function calendarGraphqlRequest<T>(
  query: string,
  variables?: Record<string, any>
): Promise<T | undefined> {
  try {
    const apiUrl = process.env.CALENDAR_API_URL;
    if (!apiUrl) {
      console.error("Error: CALENDAR_API_URL is not defined.");
      throw new Error("CALENDAR_API_URL is not defined. Please check your environment variables.");
    }
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      // Log more details for debugging
      const errorBody = await response.text();
      console.error(
        `GraphQL request failed with status ${response.status}: ${response.statusText}`,
        errorBody
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL Errors:", result.errors);
      return undefined; 
    }

    return result.data as T;
  } catch (error) {
    console.error("Error during GraphQL request:", error);
    return undefined;
  }
}

export default calendarGraphqlRequest; 